import styled, { css, keyframes } from 'styled-components'

import colors from 'styles/colors'

interface IStyledActionCardProps {
    $selected?: boolean
    $disabled?: boolean
    $customStyle?: string | ReturnType<typeof css> | undefined
    $addNewText?: boolean
}

export const StyledActionCard = styled.div<IStyledActionCardProps>`
    width: 100%;
    background: ${colors.white89deg};
    box-shadow: 0 0.4rem 2rem rgba(0, 0, 0, 0.05);
    border-radius: 2.5rem;
    display: flex;
    flex-direction: column;
    padding: 1.7rem 2rem 1.5rem 1.5rem;
    margin-bottom: 1rem;
    min-height: 5rem;
    transition: all ease-in-out 0.3s;
    // border: 0.2rem solid transparent;
    position: relative;
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    border: ${props => props.$selected && `0.2rem solid ${colors.blueLighter}`};
    touch-action: ${props => props.$disabled && 'none'};
    pointer-events: ${props => props.$disabled && 'none'};
    cursor: ${props => props.$addNewText && 'pointer'};

    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
    user-select: none;
    outline: none;

    &:focus,
    &:focus-visible,
    &:active {
        outline: none;
    }
    ${props =>
        props.$customStyle &&
        css`
            ${props.$customStyle};
        `}
`
const IconAnimation = keyframes`
  100% {
    transform: scale(1);
  }
  0% {
    transform: scale(0);
  }
`

export const SelectIconWrapper = styled.div`
    background-color: white;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
        overflow:visible;

    position: absolute;
    top: -1.1rem;
    right: -1.1rem;
    
    animation: ${IconAnimation} 0.3s ease-in-out forwards;
`

export const SelectIcon = styled.div`
    background-color: ${colors.blueLighter};
    width: 2rem;
    height: 2rem;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
`

export const TopArea = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
`

export const Buttons = styled.div`
    display: flex;
    align-items: center;
    margin-left: 1rem;
    gap: 1rem;
`

export const Body = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
`

export const Text = styled.div<{
    $addNewText?: boolean
    $disabled?: boolean
    $isEmphasizedText?: boolean
}>`
    align-items: center;
    display: flex;
    font-size: 1.4rem;
    font-weight: 600;
    margin: 0 0 0.5rem 0;
    color: ${props =>
        props.$isEmphasizedText
            ? colors.blueLight
            : props.$addNewText ?? props.$disabled
            ? colors.ashGray
            : colors.blueDark};
    word-break: break-word;
`
export const Subtext = styled.div`
    font-style: normal;
    font-weight: 500;
    letter-spacing: 0.02em;
    font-size: 1.2rem;
    line-height: 1.5rem;
    margin: 0;
    color: ${colors.silverGray};
    word-break: break-word;
`

export const Description = styled.div`
    color: ${colors.stormyBlue};
    font-weight: 500;
    letter-spacing: 0.02em;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: 500;
    margin: 0;
`

export const IconWrapper = styled.div<{
    $iconSize?: 'small' | 'big'
    $absFix?: boolean
    $addNewText?: boolean
}>`
    width: ${props =>
        props.$iconSize === 'small'
            ? '5rem'
            : props.$iconSize === 'big'
            ? '8rem'
            : '6rem'};
    height: ${props =>
        props.$iconSize === 'small'
            ? '5rem'
            : props.$iconSize === 'big'
            ? '8rem'
            : '6rem'};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: ${colors.lightGray};
    border-radius: ${props =>
        props.$iconSize === 'small' && props.$addNewText ? '1rem' : '2rem'};
    margin-right: 1.5rem;
    padding-top: ${props => (props.$absFix ? '2rem' : '0rem')};
`

export const Arrow = styled.div<{
    $rotate?: boolean
    $isEmphasizedText?: boolean
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 3rem;
    height: 3rem;
    background-color: ${colors.lightGray};
    background: ${props => props.$isEmphasizedText && colors.blue92deg};
    border-radius: 1rem;
    margin-top: 0;
    cursor: pointer;
    color: ${colors.platinumGray};
    transition: all 0.3s ease-in-out;
    transform: ${props => props.$rotate && `rotate(180deg)`};
    svg path {
        stroke: ${props => props.$isEmphasizedText && colors.white};
    }
`

export const PendingNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.2rem;
    font-weight: 700;
    margin-right: 1rem;
    height: 2rem;
    width: 2rem;
    border-radius: 50%;
    background: ${colors.blue92deg};
    color: ${colors.white};
`

export const Suptext = styled.div`
    font-size: 1.2rem;
    margin: 0 0 0.5rem 0;
    color: ${colors.silverGray};
`

export const Avatar = styled.div`
    width: 5rem;
    height: 5rem;
    overflow: hidden;
    margin-right: 1.5rem;
    border-radius: 50%;

    > img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        display: block;
    }
`

export const Wire = styled.div`
    font-size: 1.2rem;
    font-weight: 500;
    color: ${colors.grey};
    background: #f1f1f17c;
    padding: 0.75rem;
    border-radius: 1rem;
`

export const DropDownContent = styled.div<{ $dropDownOpen?: boolean }>`
    display: ${props => !props.$dropDownOpen && `none`};
`
